/*
  Copyright (c) 2025 Fluxonix Inc. All rights reserved.
*/

// src/pages/SignupCancelled.jsx

import React from "react";
import { Box, Typography } from "@mui/material";

export default function SignupCancelled() {
  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h5" gutterBottom>
        ❌ Signup was cancelled
      </Typography>
      <Typography variant="body1">
        You can restart the signup process anytime.
      </Typography>
    </Box>
  );
}